import { colors } from '@everlywell/leaves';
import {
  Col,
  mediaQueries,
  size,
  SkeletonLoader as LeavesSkeletonLoader,
} from '@everlywell/leaves';
import styled from 'styled-components';

export type ProductGridColProps = {
  tabletVerticalUpColumns: number;
  tabletHorizontalUpColumns: number;
};

export const ProductGridCol = styled(Col)<
  ProductGridColProps & { useShadow: boolean }
>`
  display: grid;
  grid-template-columns: auto;
  row-gap: ${size.sm}px;
  column-gap: 1rem;
  align-items: stretch;
  padding-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletVerticalUp} {
    grid-template-columns: repeat(
      ${({ tabletVerticalUpColumns }) => tabletVerticalUpColumns},
      1fr
    );
    row-gap: ${size.xl2}px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    grid-template-columns: repeat(
      ${({ tabletHorizontalUpColumns }) => tabletHorizontalUpColumns},
      1fr
    );
    column-gap: 2rem;
    row-gap: ${size.xl2}px;
  }

  > div {
    border: 1px solid ${colors.green2};
    border-radius: ${size.xs1}px;
    overflow: hidden;

    &:hover {
      box-shadow: ${({ useShadow }) => useShadow && '0 7px 30px -10px #dce4e5'};
    }

    a {
      border-radius: ${size.xs1}px;
      border: none;
      height: 100%;

      /* 
      There is a known issue where border and border radius don't play well together. 
      Basically, the border does not touch the content. A solution would be using a 
      box shadow instead of a border, but each card here has a shadow on hover. The 
      other option would be using an outline instead of a border, which does not work
      on safari mobile and desktop.

      The solution below is to override the leaves border with a slightly smaller border-radius. 
      Not the best way to handle this but it's what was possible to do.
      */
      > div {
        border-top-left-radius: ${Number(size.xs1) - 2}px;
        border-top-right-radius: ${Number(size.xs1) - 2}px;
      }
    }
  }
`;

export const SkeletonLoader = styled(LeavesSkeletonLoader)`
  height: 305px;

  ${mediaQueries.forTabletVerticalUp} {
    height: 380px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    height: 390px;
  }

  ${mediaQueries.forDesktopUp} {
    height: 430px;
  }
`;
